import { render, staticRenderFns } from "./pluck404.vue?vue&type=template&id=5aa8eb0e"
import script from "./pluck404.vue?vue&type=script&lang=js"
export * from "./pluck404.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports